import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const QUERY_GET_WIN_LOSS = gql`
  query winLossHistory($input: GetWinLoss!) {
    winLossHistory(input: $input) {
      accountNumber
      year
      properties {
        name
        propertyValue {
          month
          value
        }
      }
    }
  }
`;

export default graphql(QUERY_GET_WIN_LOSS, {
  options: props => ({
    variables: {
      input: {
        patronAccountNumber: props.accountNumber,
        year: props.year
      }
    },
    fetchPolicy: 'cache-and-network'
  })
});
